import { SpherePlatformApp } from '@sphere/platform';
import { PATHS } from './data-management.paths';
import { dataManagementApp } from './data-management';
import { importSymbolsHandler, importSymbolErrorHandler } from 'built-in-apps-shared';

export const DataManagementApp: SpherePlatformApp = {
    APP: dataManagementApp,
    PATHS,
    NOTIFICATION_EVENT_HANDLERS: [importSymbolsHandler, importSymbolErrorHandler]
};
